// --- Travel Constants ---
export const SEARCH_PAGE = "search";
export const LISTING_PAGE = "listing";
export const DETAIL_PAGE = "details";
export const REVIEW_PAGE = "review";

// --- Limits and Defaults ---
export const LIMIT = 12;

export const MAX_ROOM_COUNT = 9;
export const MIN_ROOM_COUNT = 1;
export const DEFAULT_ROOM_COUNT = 1;

export const MAX_ADULT_COUNT = 2;
export const MIN_ADULT_COUNT = 1;
export const DEFAULT_ADULT_COUNT = 2;

export const MAX_CHILDREN_COUNT = 2;
export const MIN_CHILDREN_COUNT = 0;
export const DEFAULT_CHILDREN_COUNT = 0;

export const MIN_CHILDREN_AGE = 1;
export const MAX_CHILDREN_AGE = 11;
export const DEFAULT_CHILDREN_AGE = 1;

// --- Labels ---
export const ROOMS = 'Rooms';
export const ADULTS = 'Adults';
export const CHILDREN = 'Children';

export const PRICE = 'Price';
export const LOCATION = 'Location';
export const STAR_RATING = 'Star Rating';
export const USER_REVIEW_AND_RATING = 'User Review Rating';
export const AMENITIES = 'Amenities';
export const PROPERTY_TYPE = 'Property Type';
export const HOTEL_CHAIN = 'Hotel Chain';

// --- Selected Filter Keys ---
export const SELECTED_STAR_RATING = "starRatings";
export const SELECTED_USER_REVIEW_AND_RATING = "userRatings";
export const SELECTED_AMENITIES = "amenities";
export const SELECTED_PROPERTY_TYPE = "propertyTypes";
export const SELECTED_HOTEL_CHAIN = "hotelChains";
export const SELECTED_LOCATION = "locations";
export const SELECTED_PRICE_RANGE = "priceRange";

// --- Sorting ---
export const DEFAULT_SORT = 'rating_high_price_low';
export const PRICE_LOW_TO_HIGH = 'price_low_high';
export const PRICE_HIGH_TO_LOW = 'price_high_low';
export const RATING_HIGH_TO_LOW = 'rating_high_low';

export const SORT_OPTIONS = [
  { value: DEFAULT_SORT, label: 'Popularity' },
  { value: PRICE_LOW_TO_HIGH, label: 'Price: Low to High' },
  { value: PRICE_HIGH_TO_LOW, label: 'Price: High to Low' },
  { value: RATING_HIGH_TO_LOW, label: 'Rating: High to Low' },
];

// --- Star Rating Ranges ---
export const STAR_RATING_RANGES = [
  { label: '1 Star', min: 0, max: 2 },
  { label: '2 Stars', min: 2, max: 3 },
  { label: '3 Stars', min: 3, max: 4 },
  { label: '4 Stars', min: 4, max: 5 },
  { label: '5 Stars', min: 5, max: 5.1 },
];

// --- Default Hotel ---
export const defaultHotel = {
  city: "MUMBAI",
  country: "INDIA",
};

export const INITIAL_FILTERS = {
  priceRange: null,
  locations: [],
  starRatings: [],
  userRatings: [],
  amenities: [],
  propertyTypes: [],
  hotelChains: [],
};

// --- Filter Categories and Mapping ---
export const categoryMap = {
  [LOCATION]: 'locations',
  [STAR_RATING]: 'starRatings',
  [USER_REVIEW_AND_RATING]: 'userRatings',
  [AMENITIES]: 'amenities',
  [PROPERTY_TYPE]: 'propertyTypes',
  [HOTEL_CHAIN]: 'hotelChains',
};

export const FILTER_CATEGORIES = [
  PRICE,
  LOCATION,
  STAR_RATING,
  USER_REVIEW_AND_RATING,
  AMENITIES,
  PROPERTY_TYPE,
  HOTEL_CHAIN,
];

export const HOTEL_BREADCRUMBS = {
  HOTEL_SEARCH: {
    step: 'hotelSearch',
    title: 'Hotel Search',
  },
  HOTEL_LISTING: {
    step: 'listing',
    title: 'Listing',
  },
  HOTEL_DETAILS: {
    step: 'details',
    title: 'Details',
  },
  HOTEL_REVIEW: {
    step: 'review',
    title: 'Review',
  },
}

export const NON_REFUNDABLE = { value: 'non_refundable', label: 'Non Refundable' };
export const PARTIALLY_REFUNDABLE = { value: 'partially_refundable', label: 'Partially Refundable' };